import { render, staticRenderFns } from "./auth-login-registration.vue?vue&type=template&id=646a7a43&scoped=true&"
import script from "./auth-login-registration.vue?vue&type=script&lang=js&"
export * from "./auth-login-registration.vue?vue&type=script&lang=js&"
import style0 from "./auth-login-registration.vue?vue&type=style&index=0&id=646a7a43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a7a43",
  null
  
)

export default component.exports